@if (uploadedImageUrl(); as url) {
  <img class="image" [src]="url | imageUrl" [alt]="altText()" />
}
